import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CHANGELOG_FEATURE_KEY, ChangelogState } from './changelog.reducer';

export const selectChangelogState = createFeatureSelector<ChangelogState>(CHANGELOG_FEATURE_KEY);

export const selectChangelog = createSelector(selectChangelogState, (state: ChangelogState) => state.changelog);

export const selectChangelogLoaded = createSelector(selectChangelogState, (state: ChangelogState) => state.loaded);
